import AlbumList from './AlbumList'
import AlbumShow from './AlbumShow'

export default {
  list: AlbumList,
  show: AlbumShow,
}
